var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaypal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#F5BD56;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#167DB0;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#1C567E;}\n\t.st3{fill:#1C567E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M489.2,94.5H21.9c-9.1,0-14.8,1.4-17.9,4.3c-2.7,3.3-4,8.7-4,16.7v29.9v24.1v172.3V367v28.8    c0,14.3,7.4,21.7,21.9,21.7h467.3c15.2,0,22.8-7.4,22.8-21.7V367v-25.2V169.4v-24.1v-29.9C512,101.3,504.4,94.5,489.2,94.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M376.6,216.9c-10.7,0-19.2,2.8-25.7,4.1l-2,16.3c3.2-1.6,13.5-4.4,22-4.7c8.5-0.3,13.5,1.6,11.7,8.8     c-25.2,0-42.2,5.2-45.7,21.5c-5,28,25.7,27.2,38,15l-1.5,6.7h22.5l9.7-44.6C409.6,221.3,392.4,216.6,376.6,216.9z M378.1,262.5     c-1.2,6-6,8.5-11.7,8.8c-5,0.3-9.5-4.1-6.2-9.3c2.5-4.4,9.5-5.4,13.7-5.4c1.7,0,3.8,0,5.5,0C378.9,258.6,378.6,260.4,378.1,262.5     z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "424.8,199.3 406.2,284.8 429.1,284.8 447.9,199.3 424.8,199.3 424.8,199.3    "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M320,199.5h-41.8l-18.5,85.2h24.3l6.3-28.2h17.3c17,0,31-10.4,34.8-28C346.5,208.6,332,199.5,320,199.5z      M319.2,228.5c-1.5,6.5-8,11.7-14.3,11.7h-11.3l5-23.3h12C317,216.9,320.7,222.1,319.2,228.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M157.8,216.9c-10.6,0-19,2.8-25.2,4.1l-2,16.3c3-1.6,13.1-4.4,21.5-4.7c8.4-0.3,13.3,1.6,11.8,8.8     c-24.9,0-41.7,5.2-45.1,21.5c-4.9,28,25.4,27.2,37.2,15l-1.5,6.7H177l9.6-44.6C190.6,221.3,173.3,216.6,157.8,216.9z      M159.5,262.5c-1.2,6-6.2,8.5-11.8,8.8c-4.9,0.3-9.1-4.1-5.9-9.3c2.5-4.4,9.4-5.4,13.3-5.4c2,0,3.7,0,5.7,0     C160.2,258.6,159.7,260.4,159.5,262.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "196.4,218.1 218.9,218.1 222.5,257.8 244.4,218.1 267.6,218.1 214.3,313.1 189.2,313.1 205.6,285.2      196.4,218.1 196.4,218.1    "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M101.9,199.5H60.1l-18.6,85.2h24.6l6-28.2h17.6c16.8,0,30.9-10.4,34.6-28     C128.5,208.6,114.2,199.5,101.9,199.5z M101.2,228.5c-1.5,6.5-7.8,11.7-14.1,11.7H75.6l5.3-23.3h12     C98.9,216.9,103,222.1,101.2,228.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M452.8,210.3v-10.1h-3.8v-1.4h9.1v1.4h-3.8v10.1H452.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M459.6,210.3v-11.4h2.3l2.7,8.1c0.3,0.8,0.4,1.3,0.5,1.7c0.1-0.4,0.3-1,0.6-1.8l2.7-7.9h2v11.4h-1.5v-9.6     l-3.3,9.6h-1.4l-3.3-9.7v9.7H459.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.3ca8748db73ccb9c1c12d3fcdd728103.svg";
export { ForwardRef as ReactComponent };